import React from 'react';
import { Modal, Table, Button } from 'antd';
import { type BuyoutPriceInfo } from '../../../../types/process/order-record';

interface BuyoutInfoModalProps {
  visible: boolean;
  onClose: () => void;
  buyoutInfo?: BuyoutPriceInfo;
}

export const BuyoutInfoModal: React.FC<BuyoutInfoModalProps> = ({ visible, onClose, buyoutInfo }) => {
  const columns = [
    { title: '期数', dataIndex: 'tenancy', key: 'tenancy', width: 120 },
    { title: '单期买断价', dataIndex: 'current_purchase_price', key: 'current_purchase_price', align: 'center' as const },
  ];

  return (
    <Modal 
      title="买断信息" 
      open={visible} 
      onCancel={onClose} 
      footer={[
        <Button key="confirm" type="primary" onClick={onClose}>
          知道了
        </Button>
      ]}
      width={800}
    >
      {buyoutInfo?.sku_name && (
        <div style={{ marginBottom: 16, fontWeight: 'bold' }}>
          商品规格：{buyoutInfo.sku_name}
        </div>
      )}
       <Table 
         dataSource={buyoutInfo?.buyout_list || []} 
         columns={columns} 
         pagination={false} 
         rowKey="tenancy"
         scroll={{ y: 500 }}
       />
    </Modal>
  );
};
